import { ShiftType } from "../../../../utils/models";

// Parses the start half of a `format_shift_label` string (e.g. "7am-7pm", "7:30pm-3:30am")
// into a minute-of-day value used to sort the grid rows chronologically.
const SHIFT_LABEL_START_PATTERN = /^(\d{1,2})(?::(\d{2}))?(am|pm)/i;
export function shiftLabelStartMinutes(label: string): number {
	const match = label.match(SHIFT_LABEL_START_PATTERN);
	if (!match) return Number.MAX_SAFE_INTEGER;
	const rawHour = Number(match[1]);
	const minute = match[2] ? Number(match[2]) : 0;
	const isPm = match[3].toLowerCase() === "pm";
	const hour24 = (rawHour % 12) + (isPm ? 12 : 0);
	return hour24 * 60 + minute;
}

// Match `getShiftIndexByShiftTimes`'s day/night cutover: shifts starting 4am–4pm are
// "day", everything else is "night". Keeps the icon consistent with the rest of the app.
export function shiftLabelToShiftType(label: string): ShiftType {
	const startMin = shiftLabelStartMinutes(label);
	if (startMin === Number.MAX_SAFE_INTEGER) return ShiftType.Day;
	const startHour = Math.floor(startMin / 60);
	return startHour >= 4 && startHour < 16 ? ShiftType.Day : ShiftType.Night;
}
